import axios from "axios";
import store from "@/store";
import {MessageBox, Message} from "element-ui";
import {getToken, removeToken} from "@/utils/auth";
import router from "@/router";
// create an axios instance
const service = axios.create({
    // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // baseURL: "https://go.advantest.com.cn/",
    // baseURL: "http://go-test.advantest.com.cn",
    baseURL: process.env.VUE_APP_BASE_API,
    // baseURL:'/advan_api/',
    // baseURL: process.env.VUE_APP_BASE_API,
    // baseURL: "https://ad.izhixiu.cn/",
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 60000 // request timeout
});

service.interceptors.request.use(
    (config) => {
        if (!config.url.includes('aui') && store.getters.token) {
            config.headers["Authorization"] = `Bearer ${getToken()}`;
        }
        if(config.url.includes('aui')){
            config.headers["Authorization"] = `Bearer ${sessionStorage.getItem('AliToken')}`
        }
        return config;
    },
    (error) => {
        console.log(error); // for debug
        return Promise.reject(error);
    }
);

service.interceptors.response.use(
    (response) => {
        const res = response.data;
        if (res.code != 200 && res.code != 201) {
            if (res.code == 401 || res.code == 50012 || res.code == 50014) {
                Message({message: "暂未登录，请先登录", type: "error", duration: 5 * 1000,});
                removeToken();
                store.dispatch("user/resetToken").then(() => {
                    // router.replace("/login/index?redirect=" + router.currentRoute.path);
                    router.replace("/?redirect=" + router.currentRoute.path);
                });
            } else if (res.code !=undefined) {
                Message({message: res.message || "Error", type: "error", duration: 5 * 1000,}); 
            }
            return Promise.resolve(res);
        } else {
            return res;
        }
    },
    (error) => {
        console.log("err" + error); // for debug
        let data = error.response.data;
        let status = error.response.status;
        if (status == 401) {
            Message({message: "暂未登录，请先登录", type: "error", duration: 5 * 1000,});
            removeToken();
            // router.replace("/login?redirect=" + router.currentRoute.path);
            router.replace("/?redirect=" + router.currentRoute.path);
        } else {
            Message({message: data.message, type: "error", duration: 5 * 1000,});
        }
        // new Error(error || "Error");
        return Promise.resolve(error.response.data);
    }
);

export default service;
